const pagesPersonExternalHrSaasEn = {
  actionsColumn: {
    sync: 'Sync',
    syncStarted: 'Sync started!',
  },
  dialogAlert: {
    description:
      'This action could delete data permanently and cannot be undone.',
    okLabel: 'Start sync',
    subDescription1:
      'One-way import allows data to be brought in from an external source.',
    subDescription2:
      'The incoming data replaces any existing data in the system.',
    title: 'Syncing the People data: one-way import',
  },
  pageHeader: {
    description:
      'You can easily import and export People data, with seamless asynchronous syncing.',
    title: 'Sync with external HR services',
  },
  preview: {
    addStepperNavigation: {
      title: 'Sync Result',
    },
    previewFile: {
      skipWarning: 'Skipped',
      summaryErrorMessage:
        "Rows with errors haven't been imported, but other rows have been successfully imported. If you want to import the errored rows, please correct the source data.",
      summaryWarningMessage:
        'Processing was skipped for some rows. Please check the warnings below.',
    },
  },
  syncResultColumn: {
    allSuccess: 'All Success',
    partialError: 'Partial Error',
  },
  tableHeader: {
    addIntegration: 'Add integration',
    title: 'Integrated HR service',
  },
};

export default pagesPersonExternalHrSaasEn;
